import { render, staticRenderFns } from "./general-view.vue?vue&type=template&id=88781b1c&scoped=true"
import script from "./general-view.vue?vue&type=script&lang=js"
export * from "./general-view.vue?vue&type=script&lang=js"
import style0 from "./general-view.vue?vue&type=style&index=0&id=88781b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88781b1c",
  null
  
)

export default component.exports